import {
	/*Box,*/
	Card,
	CardContent,
	//CardActionArea,
	Chip
} from '@mui/material';

import Button from '@/components/Button';

import {
    LocationPin as LocationIcon,
    Circle as CircleIcon,
    History as HistoryIcon,
    Engineering as MaintenanceIcon,
    Image as ImagesIcon,
    RemoveRedEye as ViewIcon
} from '@mui/icons-material';

export default function Resource({
    t,resource,handleResourceRental,
    handleResourceInfo,handleResourceEvents,handleResourceMaintenance,handleResourceBooking,
    openUrlModal,manage,sendMessage
}){

    // resources
    const sxCardActionResources = {
        height: '500px',
        /*
        '&:hover': {
            backgroundColor: 'rgb(129,0,0,0.1)',
        },*/
        //cursor: 'pointer'
    };    

    const resourceRented = 'rgb(129,0,0';
    const resourceNotRented = 'rgb(46,125,50';
    const resourceMaintenance = 'rgb(236,195,65';
    const resourceBooked = 'rgb(25,118,210';

    const sxCardResources = {
        marginBottom: 2,
        //width: '80%'
    };

    return (        
        <>        
        <Card 
            key={resource?.id} 
            sx={{
                ...sxCardResources,
                borderColor: 
                    resource?.situation?.maintenance ? 
                        resourceMaintenance+',0.4)'
                    : 
                        resource?.situation?.rented ? 
                            resourceRented+',0.4)'
                        : 
                            resource?.situation?.booking ?
                                resourceBooked+',0.4)'
                            :
                                resourceNotRented+',0.4)'
                ,
                borderWidth: '1px',
                borderStyle: 'solid'
            }}
        >
            {/*
            <CardActionArea
                //onClick={() => handleResourceRental(position)}
                sx={
                    maintenance ? 
                        resourceMaintenance
                    :
                        rented ?
                            resourceRented
                        :
                            resourceNotRented
                }
            >*/}
                <CardContent 
                    sx={{
                        ...sxCardActionResources,                      
                        backgroundColor: 
                            resource?.situation?.maintenance ? 
                                resourceMaintenance+',0.1)'
                            : 
                                resource?.situation?.rented ? 
                                    resourceRented+',0.1)'
                                : 
                                    resource?.situation?.booking ? 
                                        resourceBooked+',0.1)'
                                    :
                                        resourceNotRented+',0.1)'                    
                    }}                  
                >                    
                    <div className='text-center mb-4'>
                        {
                            manage ?
                                <Button
                                    className='h-15'
                                    color={                                
                                        resource?.situation?.maintenance ?
                                            'warning'
                                        :
                                            resource?.situation?.rented ? 
                                                'error'
                                            :
                                                resource?.situation?.booking ? 
                                                    'primary'
                                                :
                                                    'success'
                                    }
                                    variant='contained'
                                    text={                         
                                        resource?.situation?.maintenance ?
                                            t('resource_rentals.maintenance.out.register')
                                        :
                                            resource?.situation?.rented ? 
                                                t('resource_rentals.rentals.in.register')
                                            :
                                                resource?.situation?.booking ? 
                                                    t('resource_rentals.booking.review.button')
                                                :
                                                    t('resource_rentals.rentals.out.register')
                                    }                            
                                    onClick={() =>                         
                                        resource?.situation?.maintenance ?
                                            handleResourceMaintenance(resource)
                                        :
                                            resource?.situation?.rented ? 
                                                handleResourceRental(resource)
                                            :
                                                resource?.situation?.booking ?   
                                                    handleResourceBooking(resource)
                                                :
                                                    handleResourceRental(resource)
                                    }
                                />
                            :
                                !resource?.situation?.maintenance && !resource?.situation?.rented ?
                                    <Button
                                        className='h-15'
                                        color={resource?.situation?.booking ? 'primary' : 'success'}
                                        variant='contained'
                                        text={
                                            resource?.situation?.booking ? 
                                                t('resource_rentals.booking.out.register') 
                                            : 
                                                t('resource_rentals.booking.in.register') 
                                        }
                                        onClick={() => handleResourceBooking(resource)}
                                    />
                                :
                                    <Button
                                        className='h-15'
                                        color='error'
                                        variant='contained'
                                        text={t('resource_rentals.rentals.notavailable')}
                                        onClick={() => sendMessage(t('resource_rentals.rentals.notavailable'),'error')}
                                    />

                        }
                    </div>                    
                    <div className="text-xl font-bold text-center flex-shrink-0 mb-1 break-all">
                        {resource?.name}
                    </div>                    
                    {
                        resource?.code &&
                        <div className="text-center flex-shrink-0 mb-1">
                            <b>{resource?.code}</b>
                        </div>
                    }
                    {
                        resource?.description &&
                        <div className="text-center flex-shrink-0 mb-1">
                            {resource?.description}
                        </div>
                    }
                    {
                        resource?.identifier &&
                        <div className="text-center flex-shrink-0 mb-1">
                            {resource?.identifier}
                        </div>
                    }
                    <div className="text-xs text-center flex-shrink-0 mb-2">
                        {
                            resource?.subgroup ? 
                                t('resources.subgroup.'+resource?.subgroup?.name) === 'resources.subgroup.'+resource?.subgroup?.name ? 
                                    resource?.subgroup?.name
                                :
                                    t('resources.subgroup.'+resource?.subgroup?.name) 
                            :                                
                                t('resources.group.'+resource?.group?.name) === 'resources.group.'+resource?.group?.name ? 
                                    resource?.group?.name
                                :
                                    t('resources.group.'+resource?.group?.name)                            
                        }
                    </div>
                    <div className="text-xs text-center flex-shrink-0 mb-2">
                        {t('resources.rental.unit')+': '+t('resources.unit_id.'+resource?.unit?.code)}
                    </div>
                    <div className='text-center mb-4'>
                        {
                            resource?.situation?.maintenance ? 
                                <div className='flex items-center justify-center'>
                                    <CircleIcon color='warning' fontSize='small' className='me-1'/> {t('resources.rental.maintenance')}
                                </div>
                            :
                                resource?.situation?.rented ?
                                    <div className='flex items-center justify-center'>
                                        <CircleIcon color='error' fontSize='small' className='me-1'/> {t('resources.rental.rented')}
                                    </div>
                                :
                                    resource?.situation?.booking ? 
                                        <div className='flex items-center justify-center'>
                                            <CircleIcon color='primary' fontSize='small' className='me-1'/> {t('resources.rental.booked')}
                                        </div>
                                    :
                                        <div className='flex items-center justify-center'>
                                            <CircleIcon color='success' fontSize='small' className='me-1'/> {t('resources.rental.notrented')}
                                        </div>
                        }
                    </div>                    
                    <div className="text-center mb-2">
                        {
                            (resource?.situation?.maintenance || !resource?.situation?.rented) ?
                                <><LocationIcon/> {t('resources.rental.notrentedlocation')}</>
                            :
                                resource?.situation?.location && resource?.situation?.location?.length > 0 ?
                                    <a href={resource?.situation?.location} target='_blank'>
                                        <LocationIcon/> {resource?.situation?.event?.plan?.name}
                                    </a>
                    
                                :
                                    <><LocationIcon/> {resource?.situation?.event?.plan?.name}</>
                        }                        
                    </div>                   
                    {
                        resource?.cover &&
                        <div className='h-35 flex justify-center'>
                            <a
                                className='cursor-pointer'
                                onClick={() => openUrlModal(resource.cover?.path,true,resource.cover?.type,resource.cover?.mime,resource.cover?.name,'','',false,false)}>
                                {
                                    resource.cover?.type === 'image' ? 
                                        <img className='p-2 h-full' src={resource.cover?.path}/>
                                    :
                                        resource.cover?.type === 'pdf' ?
                                            <div className='w-full h-full'>
                                                <iframe                                                                                                        
                                                    src={resource.cover?.path}                    
                                                    style={{width:'100%', height: '100%', pointerEvents: 'none'}}
                                                ></iframe>
                                            </div>
                                        :
                                            <div className=''><ViewIcon fontSize='large'/></div>
                                }                                    
                            </a>
                        </div>
                    }                      
                </CardContent>                
            {/*</CardActionArea>*/}
            <div className="modal-buttons">
                {
                    resource?.files && resource?.files?.length > 0 &&
                    <div className='mr-1'>
                        <Button
                            icon={<ImagesIcon/>}
                            color='success'
                            onClick={() => handleResourceInfo(resource)}
                        />
                    </div>
                }
                <div className='mr-1'>
                    <Button
                        icon={<HistoryIcon/>} 
                        color='primary'                        
                        onClick={() => handleResourceEvents(resource)}
                        disabled={resource?.events?.length === 0}
                    />
                </div>
                {
                    manage &&
                    <div className='mr-1'>                    
                        <Button
                            icon={<MaintenanceIcon/>}
                            color={resource?.situation?.maintenance ? 'warning' : ''}
                            onClick={() => handleResourceMaintenance(resource)}
                        />
                    </div>
                }
            </div>
        </Card>
        </>             
    );
} 